module.exports = __webpack_public_path__ + "static/media/Vindermere Dungeon.5c49b9c4.jpg";